export const appVersion = {
    version: '1.0.0.4'
}